import {ExhibitType} from "types/ExhibitType";
import {dateTime} from "services/date";

/**
 * Transform the given exhibit type by deserializing object properties
 *
 * @internal
 * @param exhibitType
 */
export default function deserializeExhibitType(exhibitType: any): ExhibitType {
    exhibitType.created_at = dateTime(exhibitType.created_at)
    exhibitType.updated_at = dateTime(exhibitType.updated_at)

    return exhibitType;
}